import { useMemo } from 'react'
import { useScenarioItems } from './useScenarioItems'
import type { ScenarioItem } from '../../core/domain/models'

export function useItemSuggestions(
  scenarioId: string,
  searchQuery: string,
  isVisible: boolean,
  excludeItems: string[]
) {
  const { items: allItems, loading } = useScenarioItems(scenarioId)

  const suggestions = useMemo<ScenarioItem[]>(() => {
    if (!isVisible || !scenarioId) return []

    const normalizedQuery = searchQuery.trim().toLowerCase()
    const normalizedExclude = excludeItems.map((name) => name.trim().toLowerCase())

    // Filter items
    let filtered = allItems.filter((item) => {
      // Exclude items already in the list
      if (normalizedExclude.includes(item.name.trim().toLowerCase())) {
        return false
      }
      // Match query
      if (normalizedQuery) {
        return item.name.toLowerCase().includes(normalizedQuery)
      }
      return true
    })

    // Sort: usage count descending, then recent usage
    filtered.sort((a, b) => {
      if (b.usageCount !== a.usageCount) {
        return b.usageCount - a.usageCount
      }
      return new Date(b.lastUsedAt).getTime() - new Date(a.lastUsedAt).getTime()
    })

    // Limit to top 20
    return filtered.slice(0, 20)
  }, [allItems, searchQuery, isVisible, excludeItems, scenarioId])

  return { suggestions, loading }
}
